<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
  
document.addEventListener("DOMContentLoaded", function() {
    var quantityInput = document.getElementById("upsell-update-48447109103934");
    if (quantityInput) {
        quantityInput.style.color = "black";
    }
});